// extracted by mini-css-extract-plugin
export default {"Root":"EditPage_Root__jedd4","QuickRefRoot":"EditPage_QuickRefRoot__xRxIB","QuickRefLink":"EditPage_QuickRefLink__YmYSU"};